import axios from '../../utils/axios';

export const getRelatedBlogsAsync = async ({tags, id}) => {
    const limit = 10;
    let queryString = tags?.length > 0 ? tags.map(tag => `tags_like=${tag}`).join('&') : "";
    queryString += `&id_ne=${id}&_limit=${limit}`;

    const response = await axios.get(`/blogs?${queryString}`);
    return response.data;

}